import React, { useState, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../api/axios"
import {
  BsCaretDownFill,
  // BsFillBellFill,
  // BsFillChatSquareDotsFill,
} from "react-icons/bs"
// import { TbBellRinging2Filled } from "react-icons/tb"

import { FaUser } from "react-icons/fa"
import { IoIosSearch } from "react-icons/io"
import { FiMenu, FiX } from "react-icons/fi"
import CandidateMenu from "./CandidateMenu"
import { SidebarContext } from "../contexts/SidebarContext"
import useAuth from "../hooks/useAuth"
//import CandidateNotification from "./CandidateNotification"

const CandidateHeader = ({ page, setQuery }) => {
  const [user, setUser] = useState({})
  const { auth } = useAuth()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [showNotification, setShowNotification] = useState(false)
  const { showSidebar, setShowSidebar } = useContext(SidebarContext)

  useEffect(() => {
    let isMounted = true
    const controller = new AbortController()

    const request = {
      signal: controller.signal,
    }

    const getUser = async () => {
      const res = await axios
        .get(`users?email=${auth.email}`, request)
        .catch(async err => {
          console.error(err?.response)
          // navigate("/", { state: { from: location }, replace: true })
        })
      if (res?.data?.data) {
        isMounted && setUser(res.data?.data?.user)
      }
    }

    const getImage = async () => {
      const res = await axios
        .get(`storage/image/${auth.path}`, request)
        .catch(async err => {
          console.error(err?.response)
          // navigate("/", { state: { from: location }, replace: true })
        })
      if (res?.data?.data) {
        isMounted && setUser(res.data?.data?.user)
      }
    }

    getUser()
getImage()
    return () => {
      isMounted = false
      controller.abort()
    }
  }, [auth])

  return (
    <nav className="sticky top-0 w-full flex items-center justify-between h-16 px-8 bg-white shadow z-40">
      <form className="relative sm:w-1/2 w-2/5 flex items-center">
        <input
          type="search"
          name="search"
          onChange={event => setQuery(event.target.value)}
          placeholder="Search by title or company"
          className="w-full bg-blue-50 pl-8 pr-4 py-2 rounded-full border-none text-black text-sm outline-none focus-within:ring-2 focus-within:ring-blue4500 placeholder:text-gray-400"
        />
        <IoIosSearch className="w-5 h-5 absolute left-2.5 text-black cursor-pointer" />
      </form>

      <div className="flex items-start text-gray-500 sm:space-x-4 space-x-2">
        {/* <span className="flex flex-col items-center hover:text-gray-800 cursor-pointer">
            <BsFillChatSquareDotsFill size={24} />
            <p className="text-xs sm:block hidden">Messaging</p>
          </span>
          <span className="flex flex-col items-center hover:text-gray-800 cursor-pointer">
            <span>
              {showNotification ? (
                <BsFillChatSquareDotsFill
                  size={24}
                  icon={showNotification ? "show" : "hide"}
                  onClick={() =>
                    setShowNotification((Visibility) => !Visibility)
                  }
                />
              ) : (
                <BsFillBellFill
                  size={24}
                  icon={showNotification ? "show" : "hide"}
                  onClick={() =>
                    setShowNotification((Visibility) => !Visibility)
                  }
                />
              )}
            </span>
            <span>
              <p className="text-xs sm:block hidden">Notifications</p>
            </span>
            {showNotification && <CandidateNotification />}
          </span> */}
        <span
          className="flex flex-col items-center justify-center hover:text-gray-800 cursor-pointer relative"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="w-6 h-6 flex justify-center rounded-full bg-gray-300 relative">
            {user?.avatar ? (
              <img
                crossOrigin="anonymous"
                src={`${process.env.REACT_APP_BASE_URL}storage/images/${user?.avatar}`}
                className="w-full h-full object-center rounded-full"
                alt=" "
              />
            ) : (
              <FaUser
                size={16}
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white"
              />
            )}
          </span>
          <span className="flex items-center">
            <p className="text-xs sm:block hidden sm:mr-1 mr-0">Me</p>
            <BsCaretDownFill size={12} />
          </span>
          {isOpen && <CandidateMenu />}
        </span>
        <span
          className="sm:pl-2 pl-0 lg:hidden flex"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? <FiX size={28} /> : <FiMenu size={28} />}
        </span>
      </div>
    </nav>
  )
}

export default CandidateHeader
